import { AllowedFileTypesEnum } from '../../enums';

export const AllowedFileMIMEType = {
  [AllowedFileTypesEnum.PDF]: 'application/pdf',
  [AllowedFileTypesEnum.DOCX]: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  [AllowedFileTypesEnum.DOC]: 'application/msword',
  [AllowedFileTypesEnum.JPG]: 'image/jpeg',
  [AllowedFileTypesEnum.JPEG]: 'image/jpeg',
  [AllowedFileTypesEnum.PNG]: 'image/png',
  [AllowedFileTypesEnum.CSV]: 'text/csv',
  [AllowedFileTypesEnum.XLS]: 'application/vnd.ms-excel',
  [AllowedFileTypesEnum.XLSX]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
